import { CSSObject } from '@emotion/react'
import { colors } from '@opallabs/spectrum'
import { DisplayMode } from './types'

export const postHeight: { [key: string]: string } = {
  mobileSingle: '667px',
  mobileNewsFeed: '678px',
}

export const postWidth = '375px'

export const baseStyles = (
  display: DisplayMode,
  hasAsset: boolean
): CSSObject => ({
  alignItems: 'center',
  background: hasAsset ? 'rgba(0,0,0,0.3)' : colors.n8.base,
  display: 'flex',
  flexDirection: 'column',
  height: postHeight[display],
  justifyContent: 'space-between',
  position: 'absolute',
  width: postWidth,
})

export const containerStyles = (
  display: DisplayMode,
  hasAsset: boolean
): CSSObject => ({
  background:
    hasAsset && display === 'mobileSingle' ? colors.n1.base : colors.white.base,
  height:
    display === 'mobileSingle'
      ? postHeight[display]
      : display === 'mobileNewsFeed' && hasAsset
        ? 'fit-content'
        : '100%',
  width: postWidth,
})
